import { render, staticRenderFns } from "./WhatsUp.vue?vue&type=template&id=01434e70&scoped=true&"
import script from "./WhatsUp.vue?vue&type=script&lang=js&"
export * from "./WhatsUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01434e70",
  null
  
)

export default component.exports